import { AuthData } from "api/resources/auth/types"

export interface CustomWindow extends Window {
  featurics?: {
    init: (config: any) => void
  }
}
declare let window: CustomWindow

export const initStatwideTracking = (
  data: Pick<AuthData["user"], "firstName" | "lastName" | "uuid" | "email">
) => {
  try {
    if (!window.featurics) return

    window.featurics.init({
      visitor: {
        appVisitorId: data.uuid,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
      },
    })
  } catch (error) {
    console.error("Error initializing Statwide tracking", error)
  }
}
